import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, Typography } from '@material-ui/core';
import useStyles from './styles';

/**
 *
 * @param {String} label - button text
 * @param {String} color - color for background to use from Material ui palette
 * @param {Object} styles - colour palette to be used if not present in the theme; background and label
 *
 */
const ButtonActions = ({ label, color, styles, disabled, children }) => {
  const classes = useStyles();
  const propsBackgroundColor = styles?.background ? styles.background : '';
  const propsLabelColor = styles && styles.label ? styles.label : 'labelWhite';
  const propsRadius = styles?.radius ? styles.radius : '';
  const propsBorder = styles?.border;
  const hoverActif = styles?.hover === true ? 'disabledHover' : '';

  const handleTouchStart = () => {};

  return (
    <Button
      variant="contained"
      color={color}
      fullWidth={true}
      className={`${classes.root} ${classes[propsBackgroundColor]} ${
        classes[propsRadius]
      } ${classes[propsBorder]} ${disabled ? classes.disabled : ''} ${
        classes[hoverActif]
      }`}
      onTouchStart={handleTouchStart()}
    >
      {children ? (
        children
      ) : (
        <span className={`${classes[propsLabelColor]}`}>{label}</span>
      )}
    </Button>
  );
};

ButtonActions.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  styles: PropTypes.object,
};

export default ButtonActions;
